import { createHomeSummaryMock } from "./home.mock";
import type { GetHomeSummaryParams, HomeSummary, IHomeGateway } from "./home.types";

/** Chave do gateway da Tela Inicial no `Registry`. */
export const HOME_GATEWAY = "HomeGateway";

export const HOME_ABORTED_MESSAGE = "Consulta da Tela Inicial cancelada.";

/**
 * Origem dos dados da Tela Inicial nesta entrega (AC3/DR5): o arquivo de mock
 * versionado no próprio `hub-web`, lido por import estático.
 *
 * Não depende de `HttpClient` de propósito — `AxiosHttpClient` resolve a URL base
 * da API no construtor e falharia sem a variável de ambiente, o que impediria a
 * tela de renderizar sem backend. A assinatura assíncrona do contrato é
 * preservada para que a implementação HTTP entre no lugar desta apenas trocando
 * o registro no container.
 */
export class MockHomeGateway implements IHomeGateway {
  async getSummary({ signal }: GetHomeSummaryParams = {}): Promise<HomeSummary> {
    if (signal?.aborted) throw new Error(HOME_ABORTED_MESSAGE);

    return createHomeSummaryMock();
  }
}
